<template>
    <div>
        <div class="mb-6">
            <div class="d-flex align-center mb-1">
                <v-badge class="mt-1 ml-2 mr-6" :color="previewObj.draft == 1 ? 'grey' : 'success'" dot></v-badge>
                <h2 class="mb-0" style="font-size:24px; line-height:24px;">{{ previewObj.name }}</h2>
            </div>
            <p class="mb-1" v-html="previewObj.description"></p>
        </div>
        <span v-if="previewObj.source === 'PROFILIA'">
            <h5 class="ml-2 mb-2">{{ $t('canalsRepartition') }}</h5>
            <DonutComponent :key="donutKey" :dataSet="canalsGraphData" :legend="false" class="px-4" style="width:100%;"/>
            <div class="legend mr-6">
                <div v-for="(legend, index) in canalsLabels()" :key="'legend_' + index">
                    <span :style="'width: 20px; height:10px; display:inline-block; background-color:' + backgroundRefs[index]"></span> {{legend}}
                </div>
            </div>
        </span>
        <span v-else>
            <h5 class="ml-2 mb-2">{{ $t('entitiesRepartition') }}</h5>
            <DonutComponent :key="donutKey" :dataSet="graphData" :legend="false" class="px-4" style="width:100%;"/>
            <div class="legend mr-6">
                <div v-for="(legend, index) in labels('entities')" :key="'legend_' + index">
                    <span :style="'width: 20px; height:10px; display:inline-block; background-color:' + backgroundRefs[index]"></span> {{legend}}
                </div>
            </div>
        </span>
    </div>
</template>
<script>
import DonutComponent from '@/components/graphs/DonutComponent'

export default {
    name: "SegmentPreview",
    components:{DonutComponent},
    props: ['realTime', 'previewObj'],
    data() {
        return {
            backgroundRefs: [
                "#2563EB", "#3B82F6", "#06B6D4", "#14B8A6", "#10B981",
                "#84CC16", "#FACC15", "#F59E0B", "#FB923C", "#F97316",
                "#EF4444", "#F43F5E", "#EC4899", "#A855F7", "#6366F1",
                "#C084FC", "#64748B", "#94A3B8", "#A5F3FC", "#86EFAC"
            ],
            donutKey:0,
        }
    },
    watch: {
        canalsGraphData(val) {
            this.donutKey++;
        },
        graphData(val){
            this.donutKey++
        }
    },
    computed: {
        graphData() {
            let graphData = {}
            if(this.realTime && this.realTime.aggregations && this.realTime.aggregations['entities']){
                graphData.datasets = [];
                let dataset = {};
                dataset.label = "";
                dataset.data = Object.values(this.realTime.aggregations['entities']).map(function (obj) { return obj.value });
                dataset.backgroundColor =  this.backgroundRefs;
                graphData.datasets.push(dataset);
                graphData.labels = this.labels('entities');
            }
            
            return graphData;
        },
        canalsGraphData() {
            let canalsGraphData = {}
            if(this.realTime && this.realTime.detail && this.realTime.detail){
                canalsGraphData.datasets = [];
                let dataset = {};
                dataset.label = "";
                dataset.data = Object.values(this.realTime.detail).map(function (obj) { return obj.value });
                dataset.backgroundColor =  this.backgroundRefs;
                canalsGraphData.datasets.push(dataset);
                canalsGraphData.labels = this.canalsLabels();
            }
            
            return canalsGraphData;
        },
    },
    methods: {
        labels(type) {
            return Object.values(this.realTime.aggregations[type]).map(function (obj) { return obj.to_trad ? this.$t(obj.label) : obj.label; }, this);
        },
        canalsLabels() {
            return Object.values(this.realTime.detail).map(function (obj) { return this.$t(obj.label); }, this);
        },
    },
}
</script>
<style lang="scss">
    
</style>